import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureRefFromUrl } from '@/lib/referral';

/**
 * ReferralCapture — top-level mount that watches the URL for ?ref=CODE
 * and persists it to cookie + localStorage. Renders nothing.
 *
 * MVP-safe:
 *  - never throws
 *  - never blocks
 *  - validates code format strictly
 *  - reruns on path/search changes (covers landing → /auth and similar)
 */
export default function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    captureRefFromUrl();
  }, [location.pathname, location.search]);

  return null;
}
